module.exports = __webpack_public_path__ + "img/manifestation-success.5feadc0a.png";